import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';

import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class WlgoalResource {
  private baseUri = '/prl/wlgoals';

  constructor(private ApiService: ApiService) {}

  // GET
  findWlgoals(params: {
    expertizeId: Docorga.interfaces.naturalTypes.NExpertizeObjectId;
  }): Observable<Array<Docorga.interfaces.wlGoal.IWlgoalJson>> {
    return this.ApiService.get(`${this.baseUri}`, params);
  }
}
